
const digest = '10d5b015cd8b88e8695a64df6f97814656a7ff036064e7c9b1455a216acfe4e5';
const classes = {"wrapper":"_wrapper_4utcc_1","suffix":"_suffix_4utcc_9","prefix":"_prefix_4utcc_17","input":"_input_4utcc_25","inputPrefix":"_inputPrefix_4utcc_59"};
const css = `._wrapper_4utcc_1 {
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  width: 100%;
}
._wrapper_4utcc_1 ._suffix_4utcc_9 {
  color: #3c3f9c;
  font-weight: 600;
  font-size: 14px;
  position: absolute;
  z-index: 1;
  right: 35px;
}
._wrapper_4utcc_1 ._prefix_4utcc_17 {
  color: #3c3f9c;
  font-weight: 600;
  font-size: 14px;
  position: absolute;
  z-index: 1;
  left: 20px;
}
._wrapper_4utcc_1 ._input_4utcc_25 {
  width: -webkit-fill-available;
  border: 1px solid #e2e5ed;
  min-height: 55px;
  font-family: Poppins, sans-serif;
  font-size: 14px;
  font-weight: 400;
  border-right: 0;
  border-radius: 24.5px;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  padding: 16px 20px;
  color: #000;
  background-color: #fff;
  flex: 1;
}
._wrapper_4utcc_1 ._input_4utcc_25:disabled {
  background-color: #f3f3f3;
  opacity: 1;
}
._wrapper_4utcc_1 ._input_4utcc_25:focus {
  box-shadow: 0 0 0 3px rgba(22, 101, 216, 0.15), inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  border-color: #1665d8;
  color: #000;
}
._wrapper_4utcc_1 ._input_4utcc_25[type=number]::-webkit-outer-spin-button, ._wrapper_4utcc_1 ._input_4utcc_25[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  display: none;
}
._wrapper_4utcc_1 ._input_4utcc_25[type=number] {
  -moz-appearance: textfield;
}
._wrapper_4utcc_1 ._input_4utcc_25 input {
  padding-right: 40px;
}
._wrapper_4utcc_1 ._input_4utcc_25._inputPrefix_4utcc_59 {
  padding-left: 40px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  